import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=aae582c0&"
import script from "./detailPage.vue?vue&type=script&lang=ts&"
export * from "./detailPage.vue?vue&type=script&lang=ts&"
import style0 from "./detailPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports